"use strict";

module Patersons {

    export class IdentityService extends BaseService
    {
        triggerForgottenPan(forgottenPanDetails: Patersons.ForgottenPanDetails): ng.IHttpPromise<any> {
            return this.post("/identity/api/account/ForgottenPan", forgottenPanDetails);
        };

        triggerForgottenPassword(forgottenPasswordDetails: Patersons.ForgottenPasswordDetails): ng.IHttpPromise<any> {
            return this.post("/identity/api/account/ForgottenPassword", forgottenPasswordDetails);
        };

        changePassword(changePasswordDetails: Patersons.ChangePasswordDetails): ng.IHttpPromise<any> {
            return this.post("/identity/api/account/ChangePassword", changePasswordDetails);
        };

        changeEmail(changeEmailDetails: Patersons.ChangeEmailDetails): ng.IHttpPromise<any> {
            return this.post("/identity/api/account/ChangeEmail", changeEmailDetails);
        };

        changeMobileNumber(phoneDetails: Patersons.PhoneDetails): ng.IHttpPromise<any> {
            return this.post("/identity/api/account/ChangeMobileNumber", phoneDetails);
        };

        confirmMobileNumberChange(phoneDetails: Patersons.PhoneConfirmationDetails): ng.IHttpPromise<any> {
            return this.post("/identity/api/account/ConfirmSms", phoneDetails);
        };

        setPassword(setPasswordDetails: Patersons.SetPasswordDetails): ng.IHttpPromise<any> {
            return this.post("/identity/api/account/SetPassword", setPasswordDetails);
        };

        request2FAToken(): ng.IHttpPromise<any> {
            return this.post("/identity/api/account/Request2FAToken", null);
        };

        getSkipMobileRegistration(): ng.IHttpPromise<any> {
            return this.get("/identity/api/account/GetSkipMobileRegistration");
        };

        getIsPhoneNumberVerifyed(): ng.IHttpPromise<any> {
            return this.get("/identity/api/account/IsPhoneNumberVerifyed");
        };

        getPhoneNumber(): ng.IHttpPromise<any> {
            return this.get("/identity/api/account/GetPhoneNumber");
        };

        getUserAddressDetails(): ng.IHttpPromise<any>{
            return this.get("/identity/api/account/GetUserAddressDetails");
        }

        saveSkipMobileRegistration(skipMobileDetails: Patersons.SkipMobileDetails): ng.IHttpPromise<any> {
            return this.post("/identity/api/account/SaveSkipMobileRegistration", skipMobileDetails);
        };
    }
}
